/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReservationRequestGatewayInfoRiskData
 */
export interface CreateReservationRequestGatewayInfoRiskData {
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestGatewayInfoRiskData
     */
    clientData: string;
}

/**
 * Check if a given object implements the CreateReservationRequestGatewayInfoRiskData interface.
 */
export function instanceOfCreateReservationRequestGatewayInfoRiskData(value: object): value is CreateReservationRequestGatewayInfoRiskData {
    if (!('clientData' in value) || value['clientData'] === undefined) return false;
    return true;
}

export function CreateReservationRequestGatewayInfoRiskDataFromJSON(json: any): CreateReservationRequestGatewayInfoRiskData {
    return CreateReservationRequestGatewayInfoRiskDataFromJSONTyped(json, false);
}

export function CreateReservationRequestGatewayInfoRiskDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservationRequestGatewayInfoRiskData {
    if (json == null) {
        return json;
    }
    return {
        
        'clientData': json['clientData'],
    };
}

export function CreateReservationRequestGatewayInfoRiskDataToJSON(json: any): CreateReservationRequestGatewayInfoRiskData {
    return CreateReservationRequestGatewayInfoRiskDataToJSONTyped(json, false);
}

export function CreateReservationRequestGatewayInfoRiskDataToJSONTyped(value?: CreateReservationRequestGatewayInfoRiskData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientData': value['clientData'],
    };
}

